// extracted by mini-css-extract-plugin
export default {"wrapper":"LandingPage_wrapper__slUw-","logo":"LandingPage_logo__Dvwi0","buttonGroup":"LandingPage_buttonGroup__pw3Sm"};